
(() => {
  const CART_SECTIONS = ['cart-drawer','cart-icon-bubble'];
  let cart = null;
  let setupTimer = null;

  const icons = {
    cart: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/><path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 2-1.6L20.5 8H6.1"/></svg>',
    heart: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.4 5.4 0 0 0-7.6 0L12 5.8l-1.2-1.2a5.4 5.4 0 0 0-7.6 7.6L12 21l8.8-8.8a5.4 5.4 0 0 0 0-7.6z"/></svg>',
    minus: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>'
  };

  const interestKey = (variantId) => 'mw-restock-interest:' + variantId;

  function titleFor(card) {
    return (card.querySelector('.card__heading .full-unstyled-link')?.textContent || '').trim();
  }

  function urlFor(card) {
    return card.dataset.productUrl || card.querySelector('.card__heading .full-unstyled-link')?.href || '';
  }

  function quickAddFor(card) {
    return card.querySelector('.card > .card__content > .quick-add');
  }

  function variantsFor(card) {
    try {
      return JSON.parse(card.querySelector('.mw-card-variants-json')?.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function makeAction(label, icon, extraClass='') {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mw-card-action ' + extraClass;
    button.innerHTML = '<span>' + label + '</span>' + icon;
    return button;
  }

  function makeQty() {
    const qty = document.createElement('div');
    qty.className = 'mw-card-qty';
    qty.innerHTML =
      '<button type="button" class="mw-card-qty__step mw-card-qty__step--minus" aria-label="Minska antal">' + icons.minus + '</button>' +
      '<span class="mw-card-qty__count">1</span>' +
      '<button type="button" class="mw-card-qty__step mw-card-qty__step--plus" aria-label="Öka antal">' + icons.plus + '</button>';
    return qty;
  }

  function quickModal(card) {
    return quickAddFor(card)?.querySelector('quick-add-modal');
  }

  function nativeProductUrl(card) {
    return quickAddFor(card)?.querySelector('[data-product-url]')?.getAttribute('data-product-url') || urlFor(card);
  }

  function buildNativeQuickView(card) {
    const productUrl = nativeProductUrl(card);
    const productId = card.dataset.productId;
    if (!productUrl || !productId) return null;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mw-card-quickview';
    button.setAttribute('data-product-url', productUrl);
    button.setAttribute('aria-haspopup', 'dialog');
    button.innerHTML = 'Snabbvy<span class="loading__spinner hidden" aria-hidden="true"></span>';

    button.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      try {
        if (!customElements.get('quick-add-modal')) {
          await customElements.whenDefined('quick-add-modal');
        }

        const modal = document.querySelector('#QuickAdd-' + CSS.escape(String(productId)));
        if (!modal || typeof modal.show !== 'function') {
          console.warn('[Mama Wynja quick view] Quick-add modal not found for product', productId);
          return;
        }

        button.setAttribute('data-product-url', productUrl);
        modal.show(button);
      } catch (error) {
        console.error('[Mama Wynja quick view]', error);
      }
    });

    return button;
  }

  function setupCard(card) {
    if (card.dataset.mwGridEnhanced === 'true') return;

    const inner = card.querySelector('.card__inner');
    const quickAdd = quickAddFor(card);
    if (!inner) return;

    if (!quickAdd) {
      card.addEventListener('click', (event) => {
        if (
          event.defaultPrevented ||
          event.target.closest('a,button,input,select,textarea,dialog,.mw-card-ui,quick-add-modal')
        ) return;

        const url = urlFor(card);
        if (url) window.location.href = url;
      });

      card.dataset.mwGridEnhanced = 'true';
      return;
    }

    const ui = document.createElement('div');
    ui.className = 'mw-card-ui';

    const quickView = buildNativeQuickView(card);
    if (quickView) ui.appendChild(quickView);

    const primary = document.createElement('div');
    primary.className = 'mw-card-primary';

    const restock = quickAdd.querySelector('[data-mw-restock-interest]');
    const modalOpener = quickAdd.querySelector('modal-opener');
    const productForm = quickAdd.querySelector('product-form');
    const variantInput = productForm?.querySelector('input[name="id"]');
    const variants = variantsFor(card);

    if (restock) {
      const action = makeAction('Intresse', '', 'mw-card-interest');
      ['dialogId','productId','variantId','productTitle','productHandle'].forEach((key) => {
        action.dataset[key] = restock.dataset[key] || '';
      });

      syncInterestAction(action);

      const dialog = document.getElementById(action.dataset.dialogId);
      if (dialog) dialog._mwInterestTrigger = action;

      action.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const dialog = document.getElementById(action.dataset.dialogId);
        if (!dialog) return;

        dialog._mwInterestTrigger = action;
        setInterestDialogState(dialog, isInterestRecorded(action.dataset.variantId));
        dialog.showModal?.();
      });

      primary.appendChild(action);
    } else if (variants.length > 1 || modalOpener) {
      const control = document.createElement('div');
      control.className = 'mw-card-control mw-card-variant-control';
      control.dataset.productId = card.dataset.productId || '';

      const add = makeAction('Lägg till', icons.cart, 'mw-card-add');
      const qty = makeQty();

      const panel = buildVariantPanel(card, control, variants);
      ui.appendChild(panel);

      add.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!panel.hidden) {
          closeVariantPanel(card, panel);
        } else {
          openVariantPanel(card, panel, 'add');
        }
      });

      qty.querySelector('.mw-card-qty__step--minus').addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openVariantPanel(card, panel, 'remove');
      });

      qty.querySelector('.mw-card-qty__step--plus').addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openVariantPanel(card, panel, 'add');
      });

      control.append(add, qty);
      primary.appendChild(control);
    } else if (productForm && variantInput?.value) {
      const control = document.createElement('div');
      control.className = 'mw-card-control mw-card-simple-control';
      control.dataset.variantId = variantInput.value;

      const add = makeAction('Lägg till', icons.cart, 'mw-card-add');
      const qty = makeQty();

      add.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        mutateVariant(control.dataset.variantId, 1, control);
      });

      qty.querySelector('.mw-card-qty__step--minus').addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        mutateVariant(control.dataset.variantId, Math.max(0, quantityForVariant(control.dataset.variantId) - 1), control);
      });

      qty.querySelector('.mw-card-qty__step--plus').addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        mutateVariant(control.dataset.variantId, quantityForVariant(control.dataset.variantId) + 1, control);
      });

      control.append(add, qty);
      primary.appendChild(control);
    }

    ui.appendChild(primary);
    inner.appendChild(ui);

    card.addEventListener('click', (event) => {
      const openPanel = card.querySelector('.mw-card-variant-panel:not([hidden])');

      if (
        openPanel &&
        !event.target.closest('.mw-card-variant-panel,.mw-card-primary')
      ) {
        event.preventDefault();
        event.stopPropagation();
        closeVariantPanel(card, openPanel);
        return;
      }

      if (
        event.defaultPrevented ||
        event.target.closest('a,button,input,select,textarea,dialog,.mw-card-ui,quick-add-modal')
      ) return;

      const url = urlFor(card);
      if (url) window.location.href = url;
    });

    card.dataset.mwGridEnhanced = 'true';
    syncCard(card);
  }

  function buildVariantPanel(card, control, variants) {
    const panel = document.createElement('div');
    panel.className = 'mw-card-variant-panel';
    panel.hidden = true;

    const header = document.createElement('div');
    header.className = 'mw-card-variant-panel__header';
    header.innerHTML =
      '<span class="mw-card-variant-panel__title">Välj variant</span>' +
      '<button type="button" class="mw-card-variant-panel__close" aria-label="Stäng">×</button>' +
      '<span class="mw-card-variant-panel__hint">Scrolla för fler alternativ ↓</span>';

    header.querySelector('button').addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeVariantPanel(card, panel);
    });

    panel.appendChild(header);

    panel.addEventListener('scroll', () => updateVariantPanelScrollState(panel));

    variants.forEach((variant) => {
      const row = document.createElement('div');
      row.className = 'mw-card-variant-row' + (variant.available ? '' : ' is-sold-out');
      row.dataset.variantId = String(variant.id);

      const title = document.createElement('div');
      title.className = 'mw-card-variant-row__title';
      title.textContent = variant.title === 'Default Title' ? titleFor(card) : variant.title;

      const stepper = document.createElement('div');
      stepper.className = 'mw-card-variant-stepper';
      stepper.innerHTML =
        '<button type="button" class="mw-card-variant-step mw-card-variant-step--minus" aria-label="Minska antal">' + icons.minus + '</button>' +
        '<span class="mw-card-variant-count">0</span>' +
        '<button type="button" class="mw-card-variant-step mw-card-variant-step--plus" aria-label="Öka antal">' + icons.plus + '</button>';

      const minus = stepper.querySelector('.mw-card-variant-step--minus');
      const plus = stepper.querySelector('.mw-card-variant-step--plus');
      if (!variant.available) plus.disabled = true;

      minus.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const current = quantityForVariant(variant.id);
        if (current > 0) mutateVariant(variant.id, current - 1, row);
      });

      plus.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const current = quantityForVariant(variant.id);
        mutateVariant(variant.id, current + 1, row);
      });

      row.append(title, stepper);
      panel.appendChild(row);
    });

    return panel;
  }

  function updateVariantPanelScrollState(panel) {
    const scrollable = panel.scrollHeight > panel.clientHeight + 4;
    const atBottom = panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 6;
    panel.classList.toggle('is-scrollable', scrollable);
    panel.classList.toggle('is-at-bottom', atBottom);
  }

  function openVariantPanel(card, panel, mode) {
    document.querySelectorAll('.mw-card-variant-panel:not([hidden])').forEach((other) => {
      if (other !== panel) {
        other.hidden = true;
        other.closest('.product-card-wrapper')?.classList.remove('mw-panel-open');
      }
    });

    const title = panel.querySelector('.mw-card-variant-panel__title');
    if (title) title.textContent = mode === 'remove' ? 'Välj variant att minska' : 'Välj variant att lägga till';

    panel.hidden = false;
    panel.scrollTop = 0;
    card.classList.add('mw-panel-open');
    syncVariantPanel(panel);
    requestAnimationFrame(() => updateVariantPanelScrollState(panel));
  }

  function closeVariantPanel(card, panel) {
    panel.hidden = true;
    card.classList.remove('mw-panel-open');
  }

  function linesForVariant(variantId) {
    if (!cart?.items) return [];
    return cart.items.filter((item) => String(item.variant_id) === String(variantId));
  }

  function quantityForVariant(variantId) {
    return linesForVariant(variantId).reduce((sum, item) => sum + item.quantity, 0);
  }

  function quantityForProduct(productId) {
    if (!cart?.items) return 0;
    return cart.items.reduce((sum, item) => {
      return sum + (String(item.product_id) === String(productId) ? item.quantity : 0);
    }, 0);
  }

  function firstLineForVariant(variantId) {
    return linesForVariant(variantId)[0] || null;
  }

  function syncVariantPanel(panel) {
    panel.querySelectorAll('.mw-card-variant-row').forEach((row) => {
      const qty = quantityForVariant(row.dataset.variantId);
      const count = row.querySelector('.mw-card-variant-count');
      const minus = row.querySelector('.mw-card-variant-step--minus');
      if (count) count.textContent = String(qty);
      if (minus) minus.disabled = qty <= 0;
    });
    if (!panel.hidden) requestAnimationFrame(() => updateVariantPanelScrollState(panel));
  }

  function syncCard(card) {
    const simple = card.querySelector('.mw-card-simple-control');
    if (simple) {
      const qty = quantityForVariant(simple.dataset.variantId);
      simple.classList.toggle('has-quantity', qty > 0);
      const count = simple.querySelector('.mw-card-qty__count');
      if (count) count.textContent = String(qty);
    }

    const variant = card.querySelector('.mw-card-variant-control');
    if (variant) {
      const qty = quantityForProduct(variant.dataset.productId);
      variant.classList.toggle('has-quantity', qty > 0);
      const count = variant.querySelector('.mw-card-qty__count');
      if (count) count.textContent = String(qty);
    }

    const panel = card.querySelector('.mw-card-variant-panel');
    if (panel) syncVariantPanel(panel);
  }

  function syncAll() {
    document.querySelectorAll('.product-card-wrapper[data-product-id]').forEach(syncCard);
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      headers:{Accept:'application/json'},
      credentials:'same-origin'
    });
    if (!response.ok) throw new Error('Could not load cart');
    cart = await response.json();
    syncAll();
    return cart;
  }

  function renderCartSections(sections, itemCount) {
    if (!sections) return;

    const drawer = document.querySelector('cart-drawer');

    if (drawer && typeof itemCount === 'number') {
      drawer.classList.toggle('is-empty', itemCount === 0);
    }

    /* Use Dawn's own cart-drawer renderer so the drawer keeps its normal
       structure and event wiring. Suppress only the automatic open() call;
       collection-card changes should remain silent. */
    if (drawer && typeof drawer.renderContents === 'function' && sections['cart-drawer']) {
      const hadOwnOpen = Object.prototype.hasOwnProperty.call(drawer, 'open');
      const previousOpen = drawer.open;

      drawer.open = function () {};

      try {
        drawer.renderContents({
          id: null,
          item_count: itemCount,
          sections: sections
        });

        if (typeof itemCount === 'number') {
          drawer.classList.toggle('is-empty', itemCount === 0);
          drawer.querySelector('cart-drawer-items')?.classList.toggle('is-empty', itemCount === 0);
          drawer.querySelector('.drawer__inner')?.classList.toggle('is-empty', itemCount === 0);
        }
      } catch (error) {
        console.error('[Mama Wynja cart drawer render]', error);
      }

      setTimeout(() => {
        if (hadOwnOpen) drawer.open = previousOpen;
        else delete drawer.open;
      }, 0);

      return;
    }

    if (sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html');
      const source =
        doc.querySelector('.shopify-section') ||
        doc.body.firstElementChild ||
        doc.body;
      const target = document.querySelector('#cart-icon-bubble');
      if (source && target) target.innerHTML = source.innerHTML;
    }
  }

  async function mutateVariant(variantId, nextQuantity, loadingElement) {
    if (!variantId || loadingElement.classList.contains('is-loading')) return;
    loadingElement.classList.add('is-loading');

    try {
      if (!cart) await fetchCart();

      const line = firstLineForVariant(variantId);
      const isAdd = !line && nextQuantity > 0;
      if (!isAdd && !line) return;

      const endpoint = isAdd ? '/cart/add.js' : '/cart/change.js';
      const payload = isAdd
        ? {
            items:[{id:Number(variantId),quantity:nextQuantity}],
            sections:CART_SECTIONS,
            sections_url:window.location.pathname
          }
        : {
            id:line.key || line.id || Number(variantId),
            quantity:Math.max(0,nextQuantity),
            sections:CART_SECTIONS,
            sections_url:window.location.pathname
          };

      const response = await fetch(endpoint,{
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'X-Requested-With':'XMLHttpRequest',
          Accept:'application/json'
        },
        credentials:'same-origin',
        body:JSON.stringify(payload)
      });

      const data = await response.json();
      if (!response.ok || data.status || data.errors) {
        throw new Error(data.description || data.message || data.errors || 'Cart update failed');
      }

      await fetchCart();
      renderCartSections(data.sections, cart?.item_count ?? 0);
    } catch (error) {
      console.error('[Mama Wynja product grid]',error);
      await fetchCart().catch(()=>{});
    } finally {
      loadingElement.classList.remove('is-loading');
    }
  }

  function isInterestRecorded(variantId) {
    try {
      return !!localStorage.getItem(interestKey(variantId));
    } catch (e) {
      return false;
    }
  }

  function syncInterestAction(trigger) {
    const recorded = isInterestRecorded(trigger.dataset.variantId);
    trigger.classList.toggle('is-recorded', recorded);
    const label = trigger.querySelector('span');
    if (label) label.textContent = recorded ? 'Registrerat ✓' : 'Intresse';
    trigger.setAttribute(
      'aria-label',
      recorded ? 'Intresse registrerat – klicka för att ändra' : 'Registrera intresse'
    );
  }

  function setInterestDialogState(dialog, recorded) {
    dialog.querySelectorAll('[data-mw-interest-view]').forEach((view) => {
      view.hidden = view.dataset.mwInterestView === 'registered' ? !recorded : recorded;
    });
  }

  function interestPayload(trigger) {
    return {
      product_id: trigger.dataset.productId,
      variant_id: trigger.dataset.variantId,
      product_title: trigger.dataset.productTitle,
      product_handle: trigger.dataset.productHandle
    };
  }

  function sendInterestSignal(trigger, removed = false) {
    const payload = interestPayload(trigger);
    const eventName = removed
      ? 'mama_wynja:restock_interest_removed'
      : 'mama_wynja:restock_interest';

    try {
      if (window.Shopify?.analytics?.publish) {
        Shopify.analytics.publish(eventName, payload).catch(() => {});
      }
    } catch (e) {}

    try {
      const body = new URLSearchParams();
      body.set('form_type', 'contact');
      body.set('utf8', '✓');
      body.set('contact[email]', 'info@klassiskasken.shop');
      body.set(
        'contact[body]',
        (removed ? 'ÅTERLAGER-INTRESSE ÅTERKALLAT' : 'ÅTERLAGER-INTRESSE') +
        '\nProdukt: ' + payload.product_title +
        '\nProdukt-ID: ' + payload.product_id +
        '\nVariant-ID: ' + payload.variant_id +
        '\nHandle: ' + payload.product_handle
      );

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        credentials: 'same-origin',
        body: body.toString()
      }).catch(() => {});
    } catch (e) {}
  }

  function recordInterest(trigger) {
    if (!trigger || isInterestRecorded(trigger.dataset.variantId)) return;

    try {
      localStorage.setItem(interestKey(trigger.dataset.variantId), '1');
    } catch (e) {}

    syncInterestAction(trigger);
    sendInterestSignal(trigger, false);
  }

  function undoInterest(trigger) {
    if (!trigger || !isInterestRecorded(trigger.dataset.variantId)) return;

    try {
      localStorage.removeItem(interestKey(trigger.dataset.variantId));
    } catch (e) {}

    syncInterestAction(trigger);
    sendInterestSignal(trigger, true);
  }

  function setupCards() {
    document.querySelectorAll('.product-card-wrapper[data-product-id]').forEach(setupCard);
    if (cart) syncAll();
  }

  function scheduleSetup() {
    clearTimeout(setupTimer);
    setupTimer = setTimeout(setupCards,50);
  }

  /* Confirm or undo interest only after the customer has read the explanation. */
  document.addEventListener('click',(event)=>{
    const confirm = event.target.closest('[data-mw-interest-confirm]');
    if (confirm) {
      event.preventDefault();
      event.stopPropagation();

      const dialog = confirm.closest('dialog');
      const trigger = dialog?._mwInterestTrigger;
      if (!dialog || !trigger) return;

      recordInterest(trigger);
      setInterestDialogState(dialog, true);
      return;
    }

    const undo = event.target.closest('[data-mw-interest-undo]');
    if (undo) {
      event.preventDefault();
      event.stopPropagation();

      const dialog = undo.closest('dialog');
      const trigger = dialog?._mwInterestTrigger;
      if (!dialog || !trigger) return;

      undoInterest(trigger);
      dialog.close();
    }
  });

  /* Close the restock-interest dialog from both the X and “Inte nu”. */
  document.addEventListener('click',(event)=>{
    const closeInterest = event.target.closest('[data-mw-interest-close]');
    if (!closeInterest) return;

    event.preventDefault();
    event.stopPropagation();

    const dialog = closeInterest.closest('dialog');
    if (dialog?.open) dialog.close();
  });

  /* Clicking the shaded backdrop outside the interest dialog also closes it. */
  document.addEventListener('click',(event)=>{
    const dialog = event.target.closest?.('.mw-restock-dialog');
    if (!dialog || event.target !== dialog || !dialog.open) return;
    dialog.close();
  });

  /* When a variant panel is open, the first click anywhere outside it
     only closes the panel. It must not also trigger a link, button,
     filter, sort control, another product, etc. */
  document.addEventListener('click',(event)=>{
    const openPanels = Array.from(document.querySelectorAll('.mw-card-variant-panel:not([hidden])'));
    if (!openPanels.length) return;

    const clickedInsideOpenPanel = openPanels.some((panel)=>panel.contains(event.target));
    if (clickedInsideOpenPanel) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    openPanels.forEach((panel)=>{
      const card = panel.closest('.product-card-wrapper');
      if (card) closeVariantPanel(card,panel);
    });
  }, true);

  document.addEventListener('DOMContentLoaded',()=>{
    setupCards();
    fetchCart().catch(()=>{});

    const main = document.getElementById('MainContent');
    if (main) {
      new MutationObserver((mutations)=>{
        if (mutations.some((m)=>m.addedNodes.length || m.removedNodes.length)) scheduleSetup();
      }).observe(main,{childList:true,subtree:true});
    }

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate,(event)=>{
        /* Cart drawer/cart page updates already include the complete post-change
           cart. Use that immediately so the product cards change at the same
           moment as the cart UI instead of waiting for another network fetch. */
        if (event?.cartData && Array.isArray(event.cartData.items)) {
          cart = event.cartData;
          syncAll();
          return;
        }

        /* Product-form add responses can be partial, so fall back to /cart.js. */
        fetchCart().catch(()=>{});
      });
    }
  });

  window.addEventListener('pageshow',()=>fetchCart().catch(()=>{}));

  document.addEventListener('visibilitychange',()=>{
    if (document.visibilityState === 'visible') fetchCart().catch(()=>{});
  });
})();
